import { useUserProfile } from '../hooks/use-user-profile';
import { cn } from '../utils/cn';

type AvatarProps = {
  className?: string;
};

export function Avatar({ className }: AvatarProps) {
  const userProfile = useUserProfile();

  return (
    <div className="flex">
      <img
        src={userProfile?.avatar_url}
        aria-hidden
        className={cn('rounded-full size-12 border border-white', className)}
      />
    </div>
  );
}
